<template>
    <div class="page">
        <my-scroll scroll-state  ref="myScroll" :page="page" :on-pull="onPull" class="page-container">
            <div slot="scrollList">
                <div class="public-head">
                    <Head></Head>
                    <div class="big-baikuang">
                        <p>{{$t('total.Total')}}</p>
                        <span>{{allCount}}</span>
                    </div>
                </div>
                <div class="public-body">
                    <div class="Profile-total">
                        <div class="Profile-total-list" v-for="item in monthlyStatList" @click="monthInfo(item.monthStr)">
                            <div class="month">{{dateFormat(item.month)}}</div>
                            <div class="completed">
                                <div class="completed-container">
                                    <p class="p-title">{{$t('total.Completed')}}</p>
                                    <p class="p-number">{{item.takeCount}}</p>
                                </div>
                            </div>
                            <div class="progess">
                                <div class="progess-container">
                                    <p class="p-title">{{$t('total.InProgress')}}</p>
                                    <p class="p-number">{{item.instoreCount}}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div style="width:100%;height:500px;">

                    </div>
                </div>
            </div>
        </my-scroll>
        <!-- <div class="Profile-back" @click="back()">
            {{$t('common.Back')}}
        </div>
        <bottom></bottom> -->
        <div class="back_bt">
          <button class="back_bt_w" @click="$router.back()">{{$t('common.Back')}}</button>
        </div>
        <bottom></bottom>
    </div>
</template>
<script>
import bottom from '../Bottom.vue'
import MyScroll from '../MyScroll'
import Head from './Head'

export default {
  name: 'Total',
  components: {bottom, MyScroll, Head},
  data () {
    return {
      p: '',
      span: '',
      monthlyStatList: [],
      allCount: 0,
      locationName: localStorage.getItem('locationName'),
      page: {
        total: 0
      },
      param: null,
      isLast: false,
      pull: false
    }
  },
  created () {
    // 初始化注入&校验时请求页面数据
    this.param = {
      timestamp: new Date().getTime(),
      monthCount: 10
    }
    this.getData()
  },
  methods: {
    getData () {
      const vue = this
      this.axios({
        method: 'get',
        params: vue.param,
        url: this.api.monthlyStat
      }).then(function (response) {
        vue.allCount = response.data.allCount
        vue.page.total = response.data.allCount
        let tmpData = response.data.monthlyStatList
        for (let i = vue.param.monthCount - 10; i < tmpData.length; i++) {
          let takeCount = tmpData[i].takeCount
          let instoreCount = tmpData[i].instoreCount
          if (takeCount < 1 && instoreCount < 1) {
            continue
          }
          vue.monthlyStatList.push(tmpData[i])
        }
        if (response.data.monthlyStatList.length === response.data.allCount) {
          vue.isLast = true
        }
        vue.pull = false
        console.log(vue.monthlyStatList)
        // vue.monthlyStatList = response.data.monthlyStatList
      }).catch(function (error) {
        console.log(error.data)
      })
    },
    onPull () {
      const vue = this

      if (!vue.isLast) {
        setTimeout(() => {
          if (vue.pull) {
            return
          }
          vue.pull = true
          this.param.monthCount += 10
          // 加载完成
          this.$refs.myScroll.setState(5)
          vue.getData(vue.param)
        }, 500)
      } else {
        // 没有数据了
        this.$refs.myScroll.setState(7)
      }
    },
    back () {
      this.$router.back()
    },
    dateFormat (time) {
      let monthArr = this.$t('common.monthArr')
      time = new Date(time)
      let m = monthArr[time.getMonth()]
      let y = time.getFullYear()
      return m + ' ' + y
    },
    monthInfo (monthStr) {
      this.$router.push('/acount/month?monthStr=' + monthStr)
    }
  }
}
</script>

<style src="../../assets/css/bootstrap.css" scoped>
</style>
<style scoped>
    .Profile-total {
        width: 93.33%;
        height: auto;
        min-height: 5.53rem;
        margin-top: 0.23rem !important;
        /* background-color: #000000; */
        margin: auto;
        /*overflow: hidden;*/
    }

    .Profile-total-list {
        width: 100%;
        height: 0.8rem;
        background-color: #FFFFFF;
        margin-top: 0.11rem;
        box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.16);
        border-radius: 0.1rem;
        overflow: hidden;
        color: #ACACAC;
    }

    .Profile-total-list-nav {
        margin-top: 0.17rem;
        margin-left: 26.06%;
        overflow: hidden;
    }

    .Profile-total-list-nav p {
        float: left;
        margin-bottom: 0 !important;
        margin-left: 12.8% !important;
        font-size: 0.125rem;
        font-weight: 900;
        line-height: 0.15rem;
    }

    .Profile-total-list-number {
        margin-top: 0.035rem;
        margin-left: 26.06%;
    }

    .Profile-total-list-number p {
        color: #000000;
        font-size: 0.18rem !important;
        font-family: 'Poppins-Regular';
        font-weight: 400 !important;
        line-height: 0.21rem !important;
        float: left;
        margin-bottom: 0 !important;
        margin-left: 18.93% !important;
        /*font-size: 0.125rem;*/
        /*font-weight: 400;*/
        /*line-height: 0.15rem;*/
    }

    .Profile-total-list-date {
        position: absolute;
        margin-left: 5.86%;
        font-size: 0.15rem;
        font-family: 'Poppins-Regular';
        font-weight: 900;
        color: #000000;
        line-height: 0.005rem;
    }

    .Profile-back {
        text-align: center;
        position: fixed;
        width: 82.4%;
        height: 0.58rem;
        bottom: 1.5rem;
        /* margin-left: 8.8%; */
        /* margin-top: 0.33rem !important; */
        box-shadow: 0px 10px 20px rgba(0, 0, 0, 0.16);
        border-radius: 84px;
        background-color: #FFFFFF;
        /* color: #052460; */
        color: var(--primary-inverted-button-text-color);
        font-size: 0.2rem;
        /*font-weight: bold;*/
        font-family: Poppins-Bold;
        line-height: 0.58rem;
        margin-bottom: 0.19rem !important;
        max-width: 400px;
        left: 50%;
        -webkit-transform: translateX(-50%);
        transform: translateX(-50%);
    }

    .month {
        width: 25%;
        display: inline-block;
        height: 100%;
        line-height: 0.8rem;
        font-size: 0.15rem;
        font-weight: 400;
        color: #000000;
        margin-left: 0.1rem;
        font-family: 'Poppins-Regular';
    }

    .completed {
        width: 25%;
        display: inline-block;
        position: relative;
        top: -0.15rem;
    }

    .progess {
        width: 25%;
        display: inline-block;
        margin-left: 0.3rem;
        position: relative;
        top: -0.15rem;
    }
    .completed-container{
        display: flex;
        flex-direction: column;
        align-items: flex-end;
    }
    .progess-container{
        display: flex;
        flex-direction: column;
        align-items: flex-end;
    }
    .p-title {
        font-weight: 400;
        font-family: 'Poppins-Regular';
        color: var(--primary-label-color);
        text-wrap: nowrap;
    }

    .p-number {
        display: block;
        font-family: 'Poppins-Regular';
        color: var(--primary-text-color);
        font-size: 0.18rem;
        font-weight: 400;
        line-height: 0.15rem;
        /* margin-top: 0.1rem; */
    }
    .public-body{
        min-height: calc(64vh) !important;
        margin-bottom: 1.2rem;
    }
    .my-scroll{
        /* margin-bottom: 1rem; */
        /* padding-bottom: 1rem; */
    }
    .Profile-back{
        bottom: 0.3rem;
    }
</style>
<style lang="less" scoped>
  .page {
    .page-container{
      max-height: 100vh;
      max-height: 100svh;
      max-height: 100dvh;
      overflow-y: auto;
    }
    .back_bt {
      position: fixed;
      width: 82%;
      // left: 9%;
      bottom: 0.4rem;
      z-index: 999;
      max-width: 400px;
      left: 50%;
      transform: translateX(-50%);
      .back_bt_w {
        width: 100%;
        height: 0.58rem;
        // background: rgba(255, 255, 255, 1);
        background: var(--primary-inverted-button-bg-color);
        box-shadow: 0rem 0.05rem 0.1rem rgba(0, 0, 0, 0.16);
        opacity: 1;
        border-radius: 0.42rem;
        border: none;
        // color: rgba(5, 36, 96, 1);
        color: var(--primary-inverted-button-text-color);
        line-height: 0.235rem;
        font-size: 0.2rem;
        /*font-weight: bold;*/
        font-family: Poppins-Bold;
      }
      .back_bt_b {
        margin-top: 0.1rem;
        width: 100%;
        height: 0.58rem;
        // background: linear-gradient(113deg, rgba(5, 36, 96, 1) 0%, rgba(31, 157, 197, 1) 100%);
        // background: linear-gradient(to right, #191E96 , #00BEF5 );
        background: linear-gradient(to right, #01BAFF , #01BAFF );
        box-shadow: 0rem 0.05rem 0.1rem rgba(5, 36, 96, 0.3);
        border-radius: 0.42rem;
        border: none;
        color: #ffffff;
        line-height: 0.235rem;
        font-size: 0.2rem;
        /*font-weight: bold;*/
        font-family: Poppins-Bold;
      }
    }
    .bottom {
      position: fixed;
      bottom: 0.06rem;
      max-width: 400px;
      max-width: 400px;
      left: 50%;
      -webkit-transform: translateX(-50%);
      transform: translateX(-50%);
    }
  }
  .loading-container{
    display: flex;
    justify-content: center;
    align-items: center;
    color: var(--primary-label-color);
    padding: 10px;
    cursor: pointer;
    gap: 10px;
    font-size: 18px;
  }
  .loading-spinner {
    -webkit-animation:spin 1.5s linear infinite;
    -moz-animation:spin 1.5s linear infinite;
    animation:spin 1.5s linear infinite;
  }
</style>



// WEBPACK FOOTER //
// src/components/Acount/Total.vue